import { useState, useEffect, useMemo } from 'react';
import candidateService from 'services/candidatoService';
import { filterCandidates, paginateData } from '../utils/reportCalculations';
// REMOVIDO: import { enrichCandidatesWithMockData } from '../utils/mockEnhancedData';
import { ITEMS_PER_PAGE } from '../utils/constants';

export const useCandidates = (searchTerm) => {
  const [allCandidates, setAllCandidates] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Cargar candidatos al iniciar
  useEffect(() => {
    loadCandidates();
  }, []);

  // Reset page to 1 when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const loadCandidates = async () => {
    try {
      setLoading(true);
      setError(null);
      const candidates = await candidateService.getAllCandidates();
      
      // Ordenar candidatos por updated_at de forma descendente
      const sortedCandidates = candidates.sort((a, b) => {
        const dateA = new Date(a.updated_at);
        const dateB = new Date(b.updated_at);
        return dateB.getTime() - dateA.getTime();
      });
      
      // Los datos vienen directamente del backend
      // El backend debe proporcionar los siguientes campos:
      // - empresa (TEXT)
      // - ajuste_cargo_porcentaje (INTEGER 0-100)
      // - estado_contratacion (TEXT: 'hired', 'interview', 'reject', 'pending')
      // - fecha_aplicacion (DATE)
      setAllCandidates(sortedCandidates);
      
      console.log('✅ Candidatos cargados del backend:', sortedCandidates.length);
      console.log('📋 Ejemplo de candidato:', sortedCandidates[0]);
    } catch (error) {
      setError(error.message || "Error al cargar candidatos");
      console.error('❌ Error al cargar candidatos:', error);
    } finally {
      setLoading(false);
    }
  };

  // Filtrar candidatos
  const filteredCandidates = useMemo(() => {
    return filterCandidates(allCandidates, searchTerm);
  }, [allCandidates, searchTerm]);

  // Paginación
  const paginationData = useMemo(() => {
    return paginateData(filteredCandidates, currentPage, ITEMS_PER_PAGE);
  }, [filteredCandidates, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const findCandidateById = (candidateId) => {
    return allCandidates.find(c => c.id_candidato === candidateId);
  };

  return {
    allCandidates,
    filteredCandidates,
    paginatedCandidates: paginationData.data,
    totalItems: paginationData.totalItems,
    totalPages: paginationData.totalPages,
    currentPage,
    hasNextPage: paginationData.hasNextPage,
    hasPrevPage: paginationData.hasPrevPage,
    loading,
    error,
    handlePageChange,
    findCandidateById,
    loadCandidates
  };
};